export default __webpack_public_path__ + "static/media/illustration-recruit-4-w.90b9399b.webp";